// extracted by mini-css-extract-plugin
export default {"Container":"Uploader_Container__2xkp3","Upload":"Uploader_Upload__9vBzq"};